module.exports = __webpack_public_path__ + "9431c39ed8b13c52ef80e5b3ac2e951c.svg";